module.exports = {"622927100":"吹麻滩镇","622927101":"大河家镇","622927102":"居集镇","622927103":"癿藏镇","622927200":"刘集乡","622927201":"石塬乡","622927202":"柳沟乡","622927203":"关家川乡","622927204":"胡林家乡","622927205":"安集乡","622927206":"寨子沟乡","622927207":"郭干乡","622927208":"徐扈家乡","622927209":"中咀岭乡","622927210":"小关乡","622927211":"铺川乡","622927212":"银川乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622927.json
// module id = 2757
// module chunks = 0